export const SET_TODO_TASK = 'SET_TODO_TASK';
export const DELETE_TODO_TASK = 'DELETE_TODO_TASK';
export const SET_SELECTED_TASK = 'SET_SELECTED_TASK';
export const SET_TODO_ITEM_STATE = 'SET_TODO_ITEM_STATE';
export const DELETE_TODO_ITEM = 'DELETE_TODO_ITEM';
export const SET_TODOS = 'SET_TODOS';
